import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullscreenOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m21.697 28.361-2.121-2.122L8.331 37.484V23.91h-3v18.757h18.756v-3H10.39zM23.85 8.332h13.633L26.24 19.574l2.121 2.121 11.245-11.244v13.638h3V5.332H23.85z" }) }) })
});
export default SvgFullscreenOn;
